'use client';

// This component must be imported and rendered FIRST in the root layout
// It suppresses hydration warnings caused by browser extensions

if (typeof window !== 'undefined') {
  // Patch console.error and console.warn immediately
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = function(...args: any[]) {
    const shouldSuppress = args.some(arg => {
      if (typeof arg === 'string') {
        return (
          arg.includes('Hydration') ||
          arg.includes('hydration') ||
          arg.includes('did not match') ||
          arg.includes('suppressHydrationWarning') ||
          arg.includes('Text content does not match') ||
          arg.includes('server-rendered HTML') ||
          arg.includes('A tree hydrated') ||
          arg.includes('bis_skin_checked') ||
          arg.includes('bis_register') ||
          arg.includes('__processed_')
        );
      }
      if (arg && typeof arg === 'object') {
        const str = JSON.stringify(arg);
        return (
          str.includes('hydration') ||
          str.includes('Hydration') ||
          str.includes('bis_skin_checked') ||
          str.includes('bis_register')
        );
      }
      return false;
    });

    if (!shouldSuppress) {
      originalError.apply(console, args);
    }
  };

  console.warn = function(...args: any[]) {
    const shouldSuppress = args.some(arg => {
      if (typeof arg === 'string') {
        return (
          arg.includes('Hydration') ||
          arg.includes('hydration') ||
          arg.includes('did not match') ||
          arg.includes('Text content does not match') ||
          arg.includes('server-rendered HTML')
        );
      }
      return false;
    });

    if (!shouldSuppress) {
      originalWarn.apply(console, args);
    }
  };
}

export default function SuppressHydrationWarnings() {
  return null;
}
